// 국가별 K-PASS 결과지 정책 타입.
// defaultReportType 은 백엔드 ReportType 상수와 동일 문자열을 사용한다.

export enum ReportTypeValue {
  STANDARD = "standard", // 한국표준화 결과지(지능점수 포함)
  BRAIN_ONLY = "brain-only", // 두뇌특성 결과지(두뇌유형만)
}

export interface CountryReportPolicy {
  idx: number;
  countryCode: string;
  defaultReportType: ReportTypeValue;
  allowBoth: boolean;
  createAt?: string;
  updateAt?: string;
}

export interface CountryReportPolicyPostParam {
  countryCode: string;
  defaultReportType: ReportTypeValue;
  allowBoth: boolean;
}
